// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Sp","title":"e_Tp","titleIcon":"e_Up","summary":"e_Vp","sourcesTitle":"e_Wp","sources":"e_Xp","source":"e_Yp"};